import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { IdpType, IdpProtocol } from '../../../../models/sso-idp.model';
import { SsoIdpBaseService, IdpBaseModel } from '../sso-idp-base.service';
import { OauthDiscoverSettingsModel, OauthModel, OauthSettingsModel, OauthSetupModel } from './sso-oauth.model';

@Injectable()
export class SsoOauthService extends SsoIdpBaseService<OauthSettingsModel> {
  create({ is_default, name, public_id, settings }: IdpBaseModel<OauthSettingsModel>): Observable<OauthModel> {
    return this.ssoIdpHttpService
      .createOauth({
        idp: IdpType.Generic,
        is_default,
        name,
        public_id,
        settings,
      })
      .pipe(
        tap((idp) => {
          this.authStore.addSsoIdp(idp);
        }),
      );
  }

  update({ is_default, name, public_id, settings }: IdpBaseModel<OauthSettingsModel>): Observable<OauthModel> {
    return this.ssoIdpHttpService
      .updateOauth({
        idp: IdpType.Generic,
        is_default,
        name,
        protocol: IdpProtocol.Oauth,
        public_id,
        settings,
      })
      .pipe(
        tap((idp) => {
          this.authStore.updateSsoIdp(idp);
        }),
      );
  }

  getSetup(): Observable<OauthSetupModel> {
    return this.ssoIdpHttpService.getOauthSetup();
  }

  override discoverSettings(metadataUrl: string): Observable<OauthDiscoverSettingsModel> {
    return this.ssoIdpHttpService.discoverSettings(metadataUrl, IdpProtocol.Oauth);
  }
}
